<template>
   <header class="header">
      <div class="logo-section" @click="gotohome()">
        <img src="@/assets/logo.png" alt="Logo" class="logo" />
      </div>
      <button v-if="!is_login_page && !show_back" class="logout-button" @click="logout">退出登录</button>
      <button v-if="show_back" class="logout-button" @click="goBack">返回</button>
    </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  props:{
    is_login_page:{
      type: Boolean,
			default: false,
      show_back:false
    }
  },
  created() {
    if(this.$route.path.includes("card"))
    {
      this.show_back = true;
    }
  },
  methods:{
    logout() {
      localStorage.setItem('token','');
      this.$router.push(`/login`);
    },
    gotohome(){
      this.$router.push(`/welcome`);
    },
    goBack() {
        window.history.back();
        // this.$router.push('/newhome'); // 返回主页
    },
  }
}
</script>

<style scoped>
/* 顶部导航 */
.header {
  margin: 0px; 
  padding: 0px; 
  box-sizing: border-box;
  width: 100%;
  height: 86px;
  display: flex;
  background-color: #DCDCDC;
  justify-content: space-between;
  align-items: center;
  /* border:1px solid #c82333; */

  flex: 0 0 auto; /* 不增长，不收缩，自动高度 */
  /* 或者指定具体高度，例如： */
  height: 86px; /* 根据实际需要调整 */
}

.logo-section {
  width: 225px;
  height: 52px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top:17px;
  margin-bottom: 17px;
  box-sizing: border-box;
  cursor: pointer; /* 添加这行使鼠标变成小手 */
}

.logo {
  width: 225px;
  height: 52px;
  margin-left: 199px;
  box-sizing: border-box;
}
.logout-button {
  width: 148px;
  height: 42px;
  padding-top:8px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  background-color: #FF6864;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-family: AlibabaPuHuiTi-Regular;
  font-weight: 400;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 45px;
  margin-right: 218px;
}

.logout-button:hover {
  background-color: #c82333;
}
</style>